import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AttractImageVO } from '../../services/attract-screen.model';
import { AttractScreenService } from '../../services/attract-screen.service';

@Component({
  selector: 'app-console-preview',
  templateUrl: './console-preview.component.html',
  styleUrls: ['./console-preview.component.scss']
})
export class ConsolePreviewComponent implements OnInit, OnDestroy {
  private consoleImageUrl: string;
  private currentConsole: string
  private previewImages: AttractImageVO[];
  private stopSlideshow = true;

  @Input() consoleType: string;  
  @Input() images: AttractImageVO[];
  @Input() message: string;  
  @Input() messageColor: string;  
  @Input() msgBgColor: string;
  constructor(private attractScreenServ: AttractScreenService) { }

  ngOnDestroy(): void {
    this.stopSlideshow = true;
  }

  ngOnInit(): void {
    this.currentConsole = this.consoleType;
    if(this.currentConsole === 'discover') {
      this.currentConsole = 'discover_se';
    }
    this.previewImages = this.images.filter(i => !!i.url);
    this.getConsoleImage(this.currentConsole);
    if (this.images.length > 1) {
      this.startSlideShow();
    }
  }

  getConsoleImage(console: string) {
    this.currentConsole = console;
    this.consoleImageUrl = this.attractScreenServ.getConsoleImage(console, 'lg');
  }

  async startSlideShow() {
    this.stopSlideshow = false;
    await this.timeout(1000);
    let previewScreenMessages = $('.image-item');
    for(var i=0;i < previewScreenMessages.length; i++){
      let element = $(previewScreenMessages[i]);
      element.fadeIn(1000)
      .delay(2000)
      .fadeOut(1000);
      await this.timeout(4000);
      previewScreenMessages[i].style.display = 'none';
      if(i+1 === previewScreenMessages.length){
        i = -1;
      }
      if(this.stopSlideshow) break;
    }
  }

  timeout(ms:number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
